import React, { useEffect, useRef, useState } from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";
import "../interfaccia/colonneTabella/colonneTabella.css";

export default function ModaArticoliQuickSearches({
  loading, viewMode, onShowAll, onShowAssigned, onShowNeedTexts, onShowNeedImages,
  choiceGroups,
}) {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const firstChoiceRef = useRef(null);
  const close = () => {
    setOpen(false);
    buttonRef.current?.focus();
  };
  useEffect(() => {
    if (open) firstChoiceRef.current?.focus();
  }, [open]);
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
        buttonRef.current?.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open]);

  const groups = choiceGroups ?? [{ choices: [
    { id: "all", label: "Tutti gli articoli", action: onShowAll },
    { id: "assigned", label: "Assegnati a me", action: onShowAssigned },
    { id: "needTexts", label: "Da pubblicare", action: onShowNeedTexts },
    { id: "needImages", label: "Immagini da fare", action: onShowNeedImages },
  ] }];
  const choices = groups.flatMap((group) => group.choices);
  const selectedChoice = choices.find((choice) => choice.id === viewMode);
  return <div className="moda-articoli-quick-control">
    <button ref={buttonRef} type="button" title="ricerche rapide" aria-label="Ricerche rapide"
      className="dim tastoInputOrizzontale br3 moda-articoli-toolbar-button"
      aria-expanded={open} aria-controls="moda-articoli-quick-panel" disabled={loading}
      data-active={Boolean(selectedChoice)}
      aria-describedby={selectedChoice ? "moda-articoli-selected-view" : undefined}
      onClick={() => open ? close() : setOpen(true)}>
      <div aria-hidden="true">{stilePulsanti.tastoVistaAspetto}</div>
      {selectedChoice && <span id="moda-articoli-selected-view" className="moda-articoli-view-label">
        {selectedChoice.activeLabel ?? selectedChoice.label}
      </span>}
    </button>
    {open && <div id="moda-articoli-quick-panel" role="dialog" aria-label="Ricerche rapide"
      className="ordini-colonne-panel moda-articoli-quick-panel">
      <div className="ordini-colonne-panel-top">
        <strong>Ricerche rapide</strong>
        <span />
        <button type="button" title="Chiudi ricerche rapide" aria-label="Chiudi ricerche rapide" onClick={close}>×</button>
      </div>
      {groups.map((group, groupIndex) => <div key={group.label ?? groupIndex}
        role={group.label ? "group" : undefined} aria-label={group.label}
        className="moda-articoli-quick-choices">
        {group.label && <strong>{group.label}</strong>}
        {group.choices.map((choice) => <button key={choice.id} ref={choice === choices[0] ? firstChoiceRef : undefined}
          type="button" className="dim tastoBianco br3" title={choice.label}
          aria-pressed={viewMode === choice.id} disabled={loading}
          onClick={() => { choice.action?.(); close(); }}>
          {choice.label}
        </button>)}
      </div>)}
    </div>}
  </div>;
}
